export const productName = 'BRAM-X LIVE';
export const productSubtitle = 'Fantasy Match Intelligence & Real-Time Simulation';
//# sourceMappingURL=index.js.map